export default __webpack_public_path__ + "235eff51d7a9ded7a61204fa6807eaaf.bin";